/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
/*
$(document).ready(function() {
console.log(jQuery('#filter_Stanje').length);
});
*/
function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}    

function redirectLeanpay() {
  location.href = 'https://www.igabiba.si/pages/leanpay-nakup-na-obroke';
}

function hasClass(element, className) {
    return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
}

docReady(function() {
    var tasks = document.querySelector('#filter_Stanje > div > ul'),
    items = document.querySelectorAll('#filter_Stanje > div > ul > li');

  for (var i = 0, arr = ['stanje_na-zalogi', 'stanje_izslo-v-zadnjih-30-dneh', 'stanje_izide-v-naslednjih-30-dneh','stanje_vec-kot-30-dni-do-izida']; i < arr.length; i++) {
      for (var j = 0; j < items.length; j++) {
          if (~(" " + items[j].className + " ").indexOf(" " + arr[i] + " "))
              tasks.appendChild(items[j]);
      }
  }

    var leanpayBnr = document.querySelectorAll('div.card > div.leanpay');
    for (var i=0; i < leanpayBnr.length; i++) {
      leanpayBnr[i].addEventListener('click', redirectLeanpay);
    }
  
  var today = new Date();
  if (window.innerWidth < 1000) {
    pLabels = document.querySelectorAll('.product-meta__label-list > span');
    for (var j = 0; j < pLabels.length; j++) {
      if(hasClass(pLabels[j], 'product-label--custom2')) {
         // pLabels[j].classList.add("display-desktop");
        pLabels[j].style.marginTop = '2vw';
      } else {
          pLabels[j].classList.add("display-desktop");
      }
    }
  }
  
  //console.log("Dan: ");
  //console.log(today.getDay());
  /*
  
  var highlightedItems = document.querySelectorAll("#loyalty_callout_container:not(.dont_touch_loyalty)");
  

  highlightedItems.forEach(function(userItem) {
    console.log("inside for loop");
    console.log(userItem);
    userItem.style.visibility='hidden';
  });
  */
});

function toggleOverlay(elem) {
  console.log(elem);
  var overlay = elem.closest(".overlay-text-image");
  if (overlay.style.display === 'none'){
       overlay.style.display = 'block';
  }else{
       overlay.style.display = 'none';
  }
}

